import React from "react";
import styled from "styled-components";
import { Operation, useGetTypesContracts, useMutateXpPart } from "@mbj-front-monorepo/data-access";
import { Controller, useForm } from "react-hook-form";
import {
  CustomSelect,
  MbjButton,
  MbjHeading,
  MbjSimpleInput,
  MbjSimpleInputContainer,
  MbjSimpleTextArea,
} from "@mbj-front-monorepo/ui";
import { getDateEN, GetElementType } from "@mbj-front-monorepo/utils";

interface MbjParticulierXpEditFormCtrlProps {
  className?: string;
  ParticulierXp: GetElementType<Operation<"getParticulierXpCollection">>;
  hideModal: () => void;
}

const MbjParticulierXpEditFormCtrl = (props: MbjParticulierXpEditFormCtrlProps) => {
  const typeContractsQuery = useGetTypesContracts();
  const mutation = useMutateXpPart(props.ParticulierXp.id || -1);

  const defaultValues = {
    startAt: props.ParticulierXp.startAt ? getDateEN(new Date(props.ParticulierXp.startAt)) : "",
    endAt: props.ParticulierXp.endAt ? getDateEN(new Date(props.ParticulierXp.endAt)) : "",
    TypeContrat: props.ParticulierXp.TypeContrat?.id ? props.ParticulierXp.TypeContrat?.id.toString() : "",
    salary: props.ParticulierXp.salary,
    description: props.ParticulierXp.description,
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
  } = useForm<Operation<"putParticulierXpItem", "requestBody">>({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  return (
    <form
      onSubmit={handleSubmit((data) => {
        const datas = {
          ...data,
          TypeContrat: `/api/type_contrats/${data.TypeContrat}`,
          endAt: data.endAt ? data.endAt : undefined,
        };

        mutation.mutate(datas, {
          onSettled: () => {
            if (props.hideModal !== undefined) {
              props.hideModal();
            }
          },
        });
      })}
      className={props.className}
    >
      <MbjHeading as={"h2"}>Expérience en cours de modification : {props.ParticulierXp.Metier?.libelle}</MbjHeading>
      <MbjSimpleInputContainer errors={errors} label={"Date de début *"}>
        <MbjSimpleInput
          name={"startAt"}
          id={"startAt"}
          type={"date"}
          noPadding
          register={register}
          registerOptions={{
            required: {
              value: true,
              message: "Date d'obtention requise",
            },
          }}
        />
      </MbjSimpleInputContainer>
      <MbjSimpleInputContainer errors={errors} label={"Date de fin"}>
        <MbjSimpleInput name={"endAt"} id={"endAt"} type={"date"} noPadding register={register} />
      </MbjSimpleInputContainer>
      <MbjSimpleInputContainer errors={errors} label={"Type du contrat *"} htmlFor={"idContrat"}>
        <Controller
          name={"TypeContrat"}
          control={control}
          rules={{ required: { value: true, message: "Contrat requis" } }}
          render={({ field }) => (
            <CustomSelect
              inputId={"TypeContrat"}
              isLoading={typeContractsQuery.isLoading}
              options={typeContractsQuery.data}
              getOptionLabel={(option) => option?.libelle || ""}
              getOptionValue={(option) => option?.id + ""}
              isClearable={true}
              defaultValue={props.ParticulierXp.TypeContrat}
              onChange={(selectedOption, triggeredAction) => {
                if (selectedOption) {
                  field.onChange(selectedOption.id);
                }
                if (triggeredAction.action === "clear") {
                  field.onChange(null);
                }
              }}
            />
          )}
        />
      </MbjSimpleInputContainer>
      <MbjSimpleInputContainer errors={errors} label={"Salaire"}>
        <MbjSimpleInput
          name={"salary"}
          id={"salary"}
          type={"number"}
          noPadding
          register={register}
          registerOptions={{
            min: {
              value: 0,
              message: "Ne peut pas être négatif",
            },
            valueAsNumber: true,
          }}
        />
      </MbjSimpleInputContainer>
      <MbjSimpleInputContainer errors={errors} label={"description"}>
        <MbjSimpleTextArea name={`description`} id={`description`} noPadding register={register} />
      </MbjSimpleInputContainer>
      <MbjButton isPending={mutation.isLoading}>Confirmer</MbjButton>
    </form>
  );
};

export const MbjParticulierXpEditForm = styled(MbjParticulierXpEditFormCtrl)((props) => ({
  gap: "8px",
  display: "flex",
  flexDirection: "column",

  button: {
    alignSelf: "flex-end",
  },
}));
